module.exports = __webpack_public_path__ + "img/voucher.73db63a7.svg";